import { useState, useEffect, useContext } from 'react';
import { isUndefined } from 'lodash';
import 'dayjs/locale/pt-br';
import dayjs, {Dayjs} from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useTheme, ThemeProvider } from '@mui/material/styles';
import { Grid, Container, TextField, Stack, Button} from '@mui/material';
import Theme from '../components/Button';
// components
import Page from '../components/Page';
// utils
import { fDateFormatCalendario } from '../utils/formatTime';
import { fFormataDinheiro } from '../utils/formatNumber';

// sections
import {
  AppOrderTimeline,
  AppWebsiteVisits,
  AppWidgetSummary,
  AppConversionRates,
} from '../sections/@dashboard/app';

import {totalVendas, totalDespesas, totalVendasAno, totalVendasProdutosMes, consultaVendas, consultaDespesas} from '../services/api';

// context
import { AuthContext } from '../contexts/auth';



// ----------------------------------------------------------------------

export default function Indicadores() {
  const { logout } = useContext(AuthContext);
  const theme = useTheme();
  const [totalVendaMes, setTotalVendaMes] = useState(0);
  const [totalDespesaMes, setTotalDespesaMes] = useState(0);
  const [listaMes, setListaMes] = useState([]);
  const [vendas, setVendas] = useState([]);
  const [despesas, setDespesas] = useState([]);
  const [vendasAno, setTotalVendaAno] = useState([]);
  const [vendasProdutoMes, setVendaProdutoMes] = useState([]);
  const [dataInicio, setDataInicio] = useState( dayjs() );
  const [dataFim, setDataFim] = useState( dayjs() );
  const [usuarioParam, setUsuario] = useState('');
  
  useEffect(() => {
    
    const getTotalVendasAno = async () => {
      const response = await totalVendasAno();

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        response.data.forEach((valores) => {
          setListaMes(listaMes => [...listaMes, valores.data_venda.toString()]);
          setTotalVendaAno(vendasAno => [...vendasAno, valores.total_venda]);
        });
      }; 
    };

    getTotaisPorFiltro();
    getTotalVendasAno();
    
  },[]); 

  const getTotaisPorFiltro = () => {
    
    setTotalVendaMes([]);
    setTotalDespesaMes([]);
    setVendas([]);
    setDespesas([]);
    setVendaProdutoMes([]);

    const getTotalVendas = async () => {
      const response = await totalVendas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim));

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        setTotalVendaMes(response.data[0]); 
      }; 
    };
    
    const getTotalDespesas = async () => {
      const response = await totalDespesas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim));

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        setTotalDespesaMes(response.data.total_despesa === null || response.data.total_despesa === undefined ? 0 : response.data.total_despesa); 
      }; 
    };
    
    const getUltimasVendas = async () => {

      const response = await consultaVendas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim), '', usuarioParam);
      
      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        setVendas(response.data);
      }; 
    };

    const getUltimasDespesas = async () => {
      
      const response = await consultaDespesas(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim));

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        setDespesas(response.data);
      }; 
    };

    const getTotalVendasProdutoMes = async () => {
      const response = await totalVendasProdutosMes(fDateFormatCalendario(dataInicio), fDateFormatCalendario(dataFim));

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }
      }else {
        response.data.forEach((valores) => {
          setVendaProdutoMes(vendasProdutoMes => [...vendasProdutoMes, {"label": valores.produto.descricao, "value": valores.total_venda}]);
        });
      }; 
    };

    getTotalVendas();
    getTotalDespesas();
    getUltimasVendas();
    getUltimasDespesas();
    getTotalVendasProdutoMes();
    
  }

  const funcDescricao = (dados) => {
    
    let descricaoVenda;
       
    if (dados.produto != null) {
        descricaoVenda = dados.produto.descricao;
    }else if (localStorage.getItem(['tipo_comercio']) === '2') {
      if (dados.pedido_mesa > 0) {
          descricaoVenda = "Venda Mesa"; 
      }else {
          descricaoVenda = "Venda Balcão"; 
      }  
    }else{
        descricaoVenda = "Venda Balcão";
    };

    return descricaoVenda;
  }
  
  return (
    <Page title="Indicadores">
      <Container maxWidth="xl">
        <Stack mb={5} direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="space-between" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} locale="pt-br" >
            <DatePicker
              label="Data Inicial"
              value={dataInicio}
              onChange={(newValue) => {
                setDataInicio(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
            <DatePicker
              label="Data Fim"
              value={dataFim}
              onChange={(newValue) => {
                setDataFim(newValue);
              }}
              renderInput={(params) => <TextField {...params} fullWidth/>}
            />
          </LocalizationProvider>
          <ThemeProvider theme={Theme}>
            <Button fullWidth size="large" type="submit" variant="contained" color="neutral" onClick={getTotaisPorFiltro}>
              Consultar
            </Button>
          </ThemeProvider>
        </Stack>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary 
              title= "Total Faturamento Periodo"
              color="success" 
              total= {isUndefined(totalVendaMes.total_venda) || totalVendaMes.total_venda === null ? 0 : totalVendaMes.total_venda} 
              icon={'fa6-solid:money-bill-1'} 
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary id="1" title={"Nº Pedidos Periodo"} total={totalVendaMes.qtde_venda === null || isUndefined(totalVendaMes.qtde_venda) ? 0 : totalVendaMes.qtde_venda} color="success" icon={'icon-park-solid:transaction-order'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title={"Total Despesas Periodo"} total={totalDespesaMes} color="error" icon={'fa6-solid:money-bill-1'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title={"Lucro do Periodo"} total={(totalVendaMes.total_venda - totalDespesaMes)} color="success" icon={'fa6-solid:money-bill-1'} />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits
              title="Faturamento Anual"
              chartLabels={listaMes}
              chartData={[
                {
                  name: 'Faturamento',
                  type: 'column',
                  fill: 'solid',
                  data: vendasAno,
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Últimas Vendas"
              list={Object.values(vendas).slice(0, 5).map(dados => ({
                id: dados.id_venda,
                title: [`${dados.id_venda} - ${funcDescricao(dados)} ----- ${fFormataDinheiro(dados.valor_venda)}`],
                type: `order1`,
                time: (isUndefined(dados.data_venda) || dados.data_venda === null) ? Date.now() : dados.data_venda,
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Produtos mais vendidos no mês"
              chartData={vendasProdutoMes}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Últimas Despesas"
              list={Object.values(despesas).slice(0, 5).map(dados => ({
                id: dados.id_despesa,
                title: [`${dados.id_despesa} - ${dados.descricao === '' ? dados.tipo_despesa.descricao : dados.descricao} ----- ${fFormataDinheiro(dados.valor_pagamento)}`],
                type: `order5`,
                time:  (isUndefined(dados.data_pagamento) || dados.data_pagamento === null) ? Date.now() : dados.data_pagamento,
              }))}
            />
          </Grid>

        </Grid>
      </Container>
    </Page>
  );
}
